
export const setupConfig = () => {
    fetch("/config.json")
        .then((res) => res.json())
        .then(({ config }) => {
            window.apiConfig = config;
        })
        .catch(() => console.error("no config.json"));
}